var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"logo-footer"},[_c('van-image',{staticClass:"product-img",attrs:{"width":"211","height":"24","fit":"contain","src":require('../../assets/imgs/vechain/img-footer-powered@2x.png')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }